import * as yup from "yup";

export const ValidateSuppliersGroups = yup.object().shape({
    name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
    group_default: yup.boolean().required("Indicativo de grupo padrão não informado"),
});
